import { HttpResult } from "widgets-for-react";
import { CourseCategoryPageData } from "../../sharepointPageApi/types/pageData";
import { AllCourseCategories } from "./allCourseCategoriesBlockState";

export const allCourseCategoriesBlockApi = async (): Promise<HttpResult<AllCourseCategories>> => {
    const res = await fetch(`/api/v1/pages/course-categories`);

    if (!res.ok)
      return {
        kind: 'failed',
        status: res.status,
      }

    const data: CourseCategoryPageData[] = await res.json();

    return {
      kind: 'result',
      status: 200,
      value: data,
    };
  }
